export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Pink-1.2c9ffeb0.jpg";